import React from 'react';
import { Decoration_Type } from 'ricos-schema';

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SETTINGS = {
  mentionPrefix: "@",
  mentionTrigger: "@",
  getMentionLink: () => "#",
  repositionSuggestions: true,
  entryHeight: 34,
  additionalHeight: 17,
  visibleItemsBeforeOverflow: 5,
  popoverComponent: /* @__PURE__ */ React.createElement("div", null),
  onMentionClick: void 0,
  getMentions: (searchQuery) => new Promise(
    (resolve) => setTimeout(
      () => resolve(
        [
          { name: "Test One", slug: "testone" },
          { name: "Test One.1", slug: "testone1" },
          { name: "Test One.2", slug: "testone2" },
          { name: "Test One.3", slug: "testone3" },
          { name: "Test One.4", slug: "testone4" },
          { name: "Test One.5", slug: "testone5" },
          { name: "Test One.6", slug: "testone6" },
          { name: "Test One.7", slug: "testone7" },
          { name: "Test One.8", slug: "testone8" },
          {
            name: "Test Two",
            slug: "testwo",
            avatar: "https://via.placeholder.com/100x100?text=Image=50"
          }
        ].filter(({ name }) => name.toLowerCase().includes(searchQuery.toLowerCase()))
      ),
      250
    )
  ),
  zIndex: 9999
};
const DEFAULTS = {
  config: __spreadValues$2({}, DEFAULT_SETTINGS)
};

const MENTION_TYPE = "mention";

var styles = {"mentionPalette":"ixlP5","mention":"dD1t2","mentionViewer":"W4Qff","mentionSuggestionsEntry":"NAlox","mentionSuggestionsEntryFocused":"SeNlt","mentionSuggestionsEntryText":"uy-28","mentionSuggestionsEntryAvatar":"PBxJs","mentionSuggestions":"_7HZJv","cursorDefault":"_4Qbmc","cursorPointer":"RTwJu"};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const decorator = (element, mentionDecoration, contextualData) => {
  const { mentionData } = mentionDecoration;
  const settings = contextualData.config[MENTION_TYPE] || {};
  const { onMentionClick, onMentionHover, getMentionLink } = settings;
  const ref = React.useRef(null);
  const onMouseOver = () => onMentionHover == null ? void 0 : onMentionHover(mentionData, ref.current);
  const onClick = () => onMentionClick == null ? void 0 : onMentionClick(mentionData);
  const onKeyDown = (e) => (e.key === "Enter" || e.key === " ") && onClick();
  const cursorStyle = onMentionClick === void 0 ? styles.cursorDefault : styles.cursorPointer;
  const commonProps = {
    onMouseOver,
    ref,
    className: `${styles.mention} ${styles.mentionViewer} ${cursorStyle}`
  };
  const key = `mention-${mentionData.id}`;
  if (onMentionClick) {
    return /* @__PURE__ */ React.createElement(
      "span",
      __spreadProps(__spreadValues$1({
        key
      }, commonProps), {
        role: "link",
        tabIndex: 0,
        onKeyDown,
        onClick
      }),
      element
    );
  } else if (getMentionLink) {
    return /* @__PURE__ */ React.createElement(
      "a",
      __spreadProps(__spreadValues$1({
        key
      }, commonProps), {
        href: getMentionLink(mentionData),
        rel: "noopener noreferrer",
        tabIndex: 0
      }),
      element
    );
  } else {
    return /* @__PURE__ */ React.createElement("span", __spreadValues$1({ key }, commonProps), element);
  }
};
const MentionDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.MENTION));
  },
  decorate: ({ element, node, context }) => {
    var _a, _b;
    const mentionDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.MENTION
    );
    return decorator(element, mentionDecoration, context);
  }
};

const nodeViewDecorators = [MentionDecorator];

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginMentions = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: MENTION_TYPE,
    nodeViewDecorators
  };
};

export { MENTION_TYPE, pluginMentions };
//# sourceMappingURL=viewer.js.map
